import mobileDetect from "mobile-detect";

export const getMobilsInfo = () => {
  // let device_type = navigator.userAgent; // 获取userAgent信息
  // let md = new mobileDetect(navigator.userAgent); // 初始化mobile-detect
  // let os = md.os(); // 获取系统
  // let model = "";
  // if (os == "iOS") {
  //   // ios系统的处理
  //   os = md.os() + md.version("iPhone");
  //   model = md.mobile();
  // } else if (os == "AndroidOS") {
  //   // Android系统的处理
  //   os = md.os() + md.version("Android");
  //   let sss = device_type.split(";");
  //   let i = containsFun(sss, "Build/");
  //   if (i > -1) {
  //     model = sss[i].substring(0, sss[i].indexOf("Build/"));
  //   }
  // }
  // let mobile_models = os + "_" + model;
  return "1";
};

export const timeAgo = (date) => {
  const seconds = Math.floor((new Date() - new Date(date)) / 1000);
  const intervals = {
    年: 31536000,
    月: 2592000,
    周: 604800,
    天: 86400,
    小时: 3600,
    分钟: 60,
    秒: 1,
  };
  let counter;
  for (const interval in intervals) {
    counter = Math.floor(seconds / intervals[interval]);
    if (counter > 0) {
      if (counter === 1) {
        return counter + " " + interval + "前";
      } else {
        return counter + " " + interval + "前";
      }
    }
  }
};
